import { lightBlueGray } from "../../../styles/colors";

const textFieldStyles = {
  input: {
    height: "50px",
    border: "none",
    background: lightBlueGray,
    borderRadius: "8px",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
      borderRadius: "8px"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "&.Mui-filled": {
      backgroundColor: "orange",
      border: "none"
    },
    "&.MuiInputBase-input-MuiOutlinedInput-input": {
      color: "red",
      backgroundColor: "transparent",
      border: "none"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none" // Hide the border
    }
  },
  visibilityBtn: {
    marginRight: "5px"
  },
  icon: {
    marginRight: "4px"
  },
  visibilityContainer: { width: "20px", display: "inline-block" }
};

export default textFieldStyles;
